function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.75502 0.397461C2.65905 0.397461 0.125977 2.9249 0.125977 6.03776C0.125977 8.85228 2.18621 11.1883 4.87689 11.6105V7.67018H3.44711V6.03776H4.87689V4.79374C4.87689 3.38085 5.71562 2.60405 7.00467 2.60405C7.61823 2.60405 8.25994 2.711 8.25994 2.711V4.10137H7.55068C6.85268 4.10137 6.63315 4.53481 6.63315 4.9795V6.03776H8.19802L7.94472 7.67018H6.63315V11.6105C7.9596 11.401 9.16746 10.7242 10.0387 9.7023C10.9099 8.68037 11.3871 7.38065 11.3841 6.03776C11.3841 2.9249 8.85099 0.397461 5.75502 0.397461Z",
  fill: "#EF951B"
});

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.3b93ad83.svg";
export { ForwardRef as ReactComponent };